import {
  date,
  enum_,
  type InferOutput,
  nullable,
  number,
  object,
  optional,
  pipe,
  string,
  transform,
  array,
  picklist
} from 'valibot'

import { REPORT_SEARCH_MODE } from '@/features/shared/models'
import { MONTHLY_CUSTOMER_REPORT_STATUS_FILTER } from '@/libs/api/types'

const dateToStringSchema = pipe(
  nullable(date()),
  // Date型だった場合stringに変換
  transform((v) => (v instanceof Date ? v.toISOString() : null)),
  string()
)

const searchModeSchema = picklist([
  REPORT_SEARCH_MODE.MONTH_RANGE,
  REPORT_SEARCH_MODE.DATE_RANGE
])

// MonthlyTourReportSearchForm用のSchema (dateToString)
export const MonthlyCustomerReportSearchSchema = object({
  page: optional(number()),
  take: optional(number()),
  customerId: optional(number()),
  dcIds: optional(array(number())),
  status: optional(enum_(MONTHLY_CUSTOMER_REPORT_STATUS_FILTER)),
  yearMonthFrom: optional(dateToStringSchema), // 運行月 from
  yearMonthTo: optional(dateToStringSchema), // 運行月 to
  // 検索モード (#4421)。未指定は月単位として扱う
  searchMode: optional(searchModeSchema),
  operatingDateFrom: optional(dateToStringSchema), // 計上日 from
  operatingDateTo: optional(dateToStringSchema) // 計上日 to
})

export type MonthlyCustomerReportSearch = InferOutput<
  typeof MonthlyCustomerReportSearchSchema
>

// validateSearch用のschema (non-transform)
export const MonthlyCustomerReportSearchValidateSchema = object({
  page: optional(number()),
  take: optional(number()),
  customerId: optional(number()),
  dcIds: optional(array(number())),
  status: optional(enum_(MONTHLY_CUSTOMER_REPORT_STATUS_FILTER)),
  yearMonthFrom: optional(string()), // 運行月 from
  yearMonthTo: optional(string()), // 運行月 to
  searchMode: optional(searchModeSchema), // 検索モード (#4421)
  operatingDateFrom: optional(string()), // 計上日 from
  operatingDateTo: optional(string()) // 計上日 to
})
